import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProductPriceXCustomer } from "src/models/Products/Product.models";

interface ProductPriceXCustomerState {
  productPriceXCustomers: IProductPriceXCustomer[];
  productPriceXCustomerToEdit: IProductPriceXCustomer | null;
}

const initialState: ProductPriceXCustomerState = {
  productPriceXCustomers: [],
  productPriceXCustomerToEdit: null,
};

const ProductPriceXCustomerSlice = createSlice({
  name: "ProductPriceXCustomer",
  initialState,
  reducers: {
    setProductPriceXCustomerList: (
      state,
      action: PayloadAction<IProductPriceXCustomer[]>
    ) => {
      state.productPriceXCustomers = action.payload;
    },
    setProductPriceXCustomerToEdit: (
      state,
      action: PayloadAction<IProductPriceXCustomer | null>
    ) => {
      state.productPriceXCustomerToEdit = action.payload;
    },
    addProductPriceXCustomer: (
      state,
      action: PayloadAction<IProductPriceXCustomer>
    ) => {
      state.productPriceXCustomers.push(action.payload);
    },
    updateProductPriceXCustomer: (
      state,
      action: PayloadAction<IProductPriceXCustomer>
    ) => {
      let itemIndex = state.productPriceXCustomers.findIndex(
        item =>
          item.productPriceXCustomerId ===
          action.payload.productPriceXCustomerId
      );
      if (itemIndex !== -1)
        state.productPriceXCustomers[itemIndex] = action.payload;
    },
    deleteProductPriceXCustomer: (state, action: PayloadAction<number>) => {
      const newArray = state.productPriceXCustomers.filter(
        item => item.productPriceXCustomerId !== action.payload
      );
      state.productPriceXCustomers = newArray;
    },
  },
});

export const {
  setProductPriceXCustomerList,
  setProductPriceXCustomerToEdit,
  addProductPriceXCustomer,
  updateProductPriceXCustomer,
  deleteProductPriceXCustomer,
} = ProductPriceXCustomerSlice.actions;

export default ProductPriceXCustomerSlice.reducer;
